import jwt_decode from 'jwt-decode';
import qs from 'qs';
import AuthService from './auth';

export default function GetUser() {
  const token = localStorage.getItem('token') || sessionStorage.getItem("token");
  if (token) {
    let user:any;
    user = jwt_decode(token);
    return { userID:String(user.id) };
  }
  else {
    AuthService.logout();
    return {userID: 'none'};
  }
}
